import React from 'react'
import Avatar from '@mui/material/Avatar'
import { Icon } from '@mxenabled/mx-icons'

const BeatMaterialIcon = ({
  avatarSx,
  bgColor,
  name,
  iconColor = 'primary',
  fill = true,
  sx,
}: {
  avatarSx?: React.ComponentProps<typeof Avatar>['sx']
  bgColor?: string
  name: string
  iconColor?: React.ComponentProps<typeof Icon>['color']
  fill?: boolean
  sx?: React.ComponentProps<typeof Icon>['sx']
}) => {
  return (
    <Avatar
      sx={{
        bgcolor: bgColor,
        width: 32,
        height: 32,
        ...avatarSx,
      }}
      variant="rounded"
    >
      <Icon color={iconColor} fill={fill} name={name} size={20} sx={sx} />
    </Avatar>
  )
}

export default BeatMaterialIcon
